<ng-container *transloco="let t">
  <ng-container *ngIf="(app.splashVisible$ | async) === true">
    <p-dialog [visible]="true" styleClass="dialog-small" [draggable]="false" [modal]="true" [closable]="false">
      <div class="p-text-center">
        <div class="logo">
          <img src="/assets/images/logo.png">
        </div>
        <h1>Assessment Runner</h1>
        <p>
          <label>{{ t('common.labels.version') }}</label>
          {{ version }}
        </p>
        <p>
          <label>{{ t('common.labels.logged_in_as') }}</label>
          {{ name }}
        </p>
        <button pButton type="button" [label]="t('common.labels.ok')" (click)="app.hideSplashScreen()"></button>
      </div>
    </p-dialog>
  </ng-container>
</ng-container>
